export default __webpack_public_path__ + "static/media/cancel.6fece1c8.svg";